/**
 * Size Recs Queries
 */

import gql from 'graphql-tag'

export const getSizeRecRequestsQuery = gql`
  query getSizeRecItems($limit: Int $offset: Int){
    result: getSizeRecItems(limit: $limit offset: $offset) {
      fullCount
      results {
        id
        sizeRecId: size_rec_id
        productId: product_id
        productName: product_name
        shortDescription: short_description
        profileOwner: profile_owner
        status
        createdAt: created_at
        score
        feedback_id,
        unit,
        height,
        weight,
        chest,
        waist,
        low_hips,
        inside_leg_height
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecs/data.ts